var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemainingCapacity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.83333 7.3335C4.18696 7.3335 4.52609 7.47397 4.77614 7.72402C5.02619 7.97407 5.16667 8.31321 5.16667 8.66683V10.0002H11.8333V8.66683C11.8333 8.31321 11.9738 7.97407 12.2239 7.72402C12.4739 7.47397 12.813 7.3335 13.1667 7.3335C13.5203 7.3335 13.8594 7.47397 14.1095 7.72402C14.3595 7.97407 14.5 8.31321 14.5 8.66683V11.3335C14.5 11.6871 14.3595 12.0263 14.1095 12.2763C13.8594 12.5264 13.5203 12.6668 13.1667 12.6668H3.83333C3.47971 12.6668 3.14057 12.5264 2.89052 12.2763C2.64048 12.0263 2.5 11.6871 2.5 11.3335V8.66683C2.5 8.31321 2.64048 7.97407 2.89052 7.72402C3.14057 7.47397 3.47971 7.3335 3.83333 7.3335Z",
    stroke: "#001F4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.8335 7.33333V4C3.8335 3.46957 4.04421 2.96086 4.41928 2.58579C4.79436 2.21071 5.30306 2 5.8335 2H11.1668C11.6973 2 12.206 2.21071 12.581 2.58579C12.9561 2.96086 13.1668 3.46957 13.1668 4V7.33333",
    stroke: "#001F4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.5 12.6665V13.9998",
    stroke: "#001F4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5 12.6665V13.9998",
    stroke: "#001F4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainingCapacity);
export default __webpack_public_path__ + "static/media/remainingCapacity.a1b197462f745c62a51b5aeafe410cec.svg";
export { ForwardRef as ReactComponent };